import ListFilterFieldsGeneric from './ListFilterFieldsGeneric'
let Filter = ListFilterFieldsGeneric('Patent')

export default {
  label: 'Patent',
  route: 'patent',
  fields: [
    Filter.ReferenceByMultiValueSearchRep('organisationseinheit', 'sitemap', 'organisationseinheit'),
    Filter.kumuliert(),
    Filter.Number('jahrDerPrioritaetsbegruendendenErstanmeldung', 'calendar-o'),
    Filter.ReferenceByMultiValueSearchRep('haupterfinder', 'user', 'abstractPerson'),
    Filter.String('titel'),
    Filter.String('veroeffentlichungsnummer'),
    Filter.String('lizenzen'),
    Filter.String('link'),
    Filter.String('forschungsgebiet'),
    Filter.String('kurzbeschreibung'),
    Filter.ReferenceByMultiValueSearchRep('anmelderExtern', 'sitemap', 'externeOrganisation'),
    Filter.ReferenceByMultiValueSearchRep('anmelderIntern', 'sitemap', 'organisationseinheit'),
    Filter.ReferenceByMultiValueSearchRep('ansprechpartner', 'user', 'abstractPerson'),
    Filter.ReferenceBySearchRep('land', 'globe', 'land')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/PatentFilter.js